/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: PGC用户详细信息
 */
"use strict";
angular.module("pgcUserDetailsModule", []).
controller("pgcUserDetailsCtrl", ["$scope", "$modalInstance", "httpService", "userId", function ($scope, $modalInstance, httpService, userId) {
  initStatus();
  initData();
  //初始状态
  function initStatus() {
    requestData();
  }
  //初始数据
  function initData() {
    $scope.status = {
      actionNum: 0, //切换tag页判断参数
      listData: [], //tag页面参数
      concatData: {}, //主体数据
      floatData: {}, //tag切换显示的数据
    }
  }

  function requestData() {
    httpService.http('/mcnadmin/admin/pgcuser/findById.do', {
      id: userId
    }, 'post').then(function (res) {
      var media = res.userInfo.mediaType;
      res.userInfo.mediaType = media == '0' ? '个人' : media == '1' ? '媒体' : media == '2' ? '国家' : media == '3' ? '企业' : '其他组织';
      $scope.status.listData = res.signChannels;
      $scope.status.concatData = res.userInfo;
      $scope.status.floatData = res.signChannels[0];
    })
  }
  /**
   * 关闭弹框
   */
  $scope.cancel = function () {
    $modalInstance.dismiss();
  };
  /**
   * tag页切换
   * @param {*} num  切换参数
   */
  $scope.actionTag = function (num) {
    $scope.status.actionNum = num;
    $scope.status.floatData = $scope.status.listData[num];
  }

  // function initStatus() {

  // };
  // function initData(){
  // 	requestData();
  // };
  // $scope.userinfo = {};
  // $scope.allMediaType = {
  // 	0: '个人',
  //     1: '媒体',
  //     2: '国家机构',
  //     3: '企业',
  //     4: '其他组织'
  // };
  // $scope.bankOptions = [{
  // 		name: "未填写",
  // 		value: 0
  // 	}, {
  // 		name: "工商银行",
  // 		value: 1,
  // 	}, {
  // 		name: "农业银行",
  // 		value: 2,
  // 	}, {
  // 		name: "中国银行",
  // 		value: 3,
  // 	}, {
  // 		name: "建设银行",
  // 		value: 4,
  // 	}, {
  // 		name: "交通银行",
  // 		value: 5,
  // 	}, {
  // 		name: "上海浦东发展银行",
  // 		value: 6,
  // 	}, {
  // 		name: "兴业银行",
  // 		value: 7,
  // 	}, {
  // 		name: "光大银行",
  // 		value: 8,
  // 	}, {
  // 		name: "深圳发展银行",
  // 		value: 9,
  // 	}, {
  // 		name: "民生银行",
  // 		value: 10,
  // 	}, {
  // 		name: "中信银行",
  // 		value: 11,
  // 	}, {
  // 		name: "招商银行",
  // 		value: 12,
  // 	}, {
  // 		name: "广东发展银行",
  // 		value: 13,
  // 	}, {
  // 		name: "华夏银行",
  // 		value: 14,
  // }];
  // $scope.confirm = function() {
  //     $modalInstance.close($scope.abc);
  // };
  // $scope.cancel = function() {
  //     $modalInstance.dismiss();
  // };
  // /**
  //  * [createProduct description] 初始化数据
  //  * @return {[type]} [description]
  //  */
  // $scope.requestData = function() {
  //     requestData();
  // };

  // function requestData() {
  //     $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/findById.do", {id:userId}, "post").then(function(data) {
  //         $scope.userinfo = data.userInfo; 
  //         $scope.userinfo.signChannels = data.signChannels;
  //         var d = data.userInfo;
  // 	    if(d.logo==null ||d.logo=="") {
  // 			$scope.headPic = "";
  // 		} else {
  // 			$scope.headPic = angular.globalConfig.pictureServer + d.logo;
  // 		}

  // 	    if(d.idNumberPic==null ||d.idNumberPic=="") {
  // 			$scope.idCardPic = "";
  // 		} else {
  // 			$scope.idCardPic = angular.globalConfig.pictureServer + d.idNumberPic;
  // 		}

  //     });
  // };
}]);
